<form #thisForm="ngForm" (ngSubmit)="submit()">
  <h3>Upload de Boleta</h3>
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do arquivo de upload</div>
    <div class="row mb-2">
      <label
        *ngIf="
          !canShowGroup([
            groups.DistribuidorMaster || groups.DistribuidorBoleta
          ])
        "
        class="col-4"
      >
        <ng-select
          notFoundText="Nenhuma boleta encontrada"
          style="width: 250px"
          data-cy="ticketTypesId"
          name="ticketTypesId"
          placeholder="Tipo de Boleta"
          [(ngModel)]="model.ticketTypesId"
        >
          <ng-option [value]="1">Cota</ng-option>
          <ng-option [value]="2">RF - Título Privado</ng-option>
          <ng-option [value]="3">RF - Título Público</ng-option>
          <ng-option [value]="4">Compromissada de Compra</ng-option>
          <ng-option [value]="5">Futuros</ng-option>
          <ng-option [value]="6">Swap-CETIP</ng-option>
          <ng-option [value]="7">Margem</ng-option>
          <ng-option [value]="8">Termo de Moeda</ng-option>
          <ng-option [value]="10">Transferência</ng-option>
          <ng-option [value]="11">Empréstimo</ng-option>
          <ng-option [value]="12">Câmbio</ng-option>
          <ng-option [value]="13">Despesas</ng-option>
          <ng-option [value]="15">Passivo</ng-option>
        </ng-select>
      </label>
    </div>

    <div class="row mb-2">
      <label
        *ngIf="
          canShowGroup([groups.DistribuidorMaster || groups.DistribuidorBoleta])
        "
        class="col-4"
      >
        <ng-select
          notFoundText="Nenhuma boleta encontrada"
          style="width: 250px"
          data-cy="ticketTypesId"
          name="ticketTypesId"
          placeholder="Tipo de Boleta"
          [(ngModel)]="model.ticketTypesId"
        >
          <ng-option [value]="15">Passivo</ng-option>
        </ng-select>
      </label>
    </div>

    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12" actions>
          Arquivo
          <input
            type="file"
            name="file"
            data-cy="uploadFile"
            (change)="openFile($event)"
          />
        </div>
      </div>
      <div class="actions">
        <input
          type="button"
          value="Upload"
          data-cy="submit"
          class="btn btn-primary me-2"
          [disabled]="model.ticketTypesId == null || file == null"
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="200"
        />
        <input
          type="button"
          value="Boleta Modelo"
          data-cy="ticketTemplate"
          class="btn btn-primary me-2"
          [disabled]="model.ticketTypesId == null"
          appDebounceClick
          (debounceClick)="ticketTemplate(model.ticketTypesId)"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>
</form>
<app-modal-error *ngIf="model.ticketTypesId !== null"></app-modal-error>
<tabela-historico-boleta></tabela-historico-boleta>
